import React, { useCallback, useEffect, useMemo, useState, useRef } from 'react';
import { Search, Check, Globe, Building2, Waves, Map as MapIcon, List, X, MapPin, Radio, ChevronDown, PenLine } from 'lucide-react';
import { MapContainer, TileLayer, Marker, Polygon, Polyline, CircleMarker, ZoomControl, useMap, useMapEvents } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
interface Region {
  id: string;
  name: string;
  type: 'Country' | 'Market' | 'City' | 'Offshore' | 'POI';
  parentId?: string;
}
export const REGIONS: Region[] = [
// Market Zones — European bidding zones & regional markets
{
  id: 'nordic',
  name: 'Nordic',
  type: 'Market'
}, {
  id: 'iberia',
  name: 'Iberian Peninsula',
  type: 'Market'
}, {
  id: 'cee',
  name: 'Central Eastern Europe',
  type: 'Market'
}, {
  id: 'balkans',
  name: 'Balkans',
  type: 'Market'
}, {
  id: 'benelux',
  name: 'Benelux',
  type: 'Market'
}, {
  id: 'de_lu',
  name: 'DE-LU (Germany-Luxembourg)',
  type: 'Market'
}, {
  id: 'de_at_lu',
  name: 'DE-AT-LU',
  type: 'Market'
}, {
  id: 'se1',
  name: 'SE1 (Luleå)',
  type: 'Market'
}, {
  id: 'se2',
  name: 'SE2 (Sundsvall)',
  type: 'Market'
}, {
  id: 'se3',
  name: 'SE3 (Stockholm)',
  type: 'Market'
}, {
  id: 'se4',
  name: 'SE4 (Malmö)',
  type: 'Market'
}, {
  id: 'no1',
  name: 'NO1 (Oslo)',
  type: 'Market'
}, {
  id: 'no2',
  name: 'NO2 (Kristiansand)',
  type: 'Market'
}, {
  id: 'no3',
  name: 'NO3 (Trondheim)',
  type: 'Market'
}, {
  id: 'no4',
  name: 'NO4 (Tromsø)',
  type: 'Market'
}, {
  id: 'no5',
  name: 'NO5 (Bergen)',
  type: 'Market'
}, {
  id: 'dk1',
  name: 'DK1 (West Denmark)',
  type: 'Market'
}, {
  id: 'dk2',
  name: 'DK2 (East Denmark)',
  type: 'Market'
}, {
  id: 'fi_zone',
  name: 'FI (Finland Zone)',
  type: 'Market'
}, {
  id: 'ee_zone',
  name: 'EE (Estonia Zone)',
  type: 'Market'
}, {
  id: 'lv_zone',
  name: 'LV (Latvia Zone)',
  type: 'Market'
}, {
  id: 'lt_zone',
  name: 'LT (Lithuania Zone)',
  type: 'Market'
}, {
  id: 'nl_zone',
  name: 'NL (Netherlands Zone)',
  type: 'Market'
}, {
  id: 'be_zone',
  name: 'BE (Belgium Zone)',
  type: 'Market'
}, {
  id: 'fr_zone',
  name: 'FR (France Zone)',
  type: 'Market'
}, {
  id: 'es_zone',
  name: 'ES (Spain Zone)',
  type: 'Market'
}, {
  id: 'pt_zone',
  name: 'PT (Portugal Zone)',
  type: 'Market'
}, {
  id: 'it_north',
  name: 'IT-North',
  type: 'Market'
}, {
  id: 'it_cnorth',
  name: 'IT-Centre-North',
  type: 'Market'
}, {
  id: 'it_csouth',
  name: 'IT-Centre-South',
  type: 'Market'
}, {
  id: 'it_south',
  name: 'IT-South',
  type: 'Market'
}, {
  id: 'it_sicily',
  name: 'IT-Sicily',
  type: 'Market'
}, {
  id: 'it_sardinia',
  name: 'IT-Sardinia',
  type: 'Market'
}, {
  id: 'at_zone',
  name: 'AT (Austria Zone)',
  type: 'Market'
}, {
  id: 'ch_zone',
  name: 'CH (Switzerland Zone)',
  type: 'Market'
}, {
  id: 'pl_zone',
  name: 'PL (Poland Zone)',
  type: 'Market'
}, {
  id: 'cz_zone',
  name: 'CZ (Czech Zone)',
  type: 'Market'
}, {
  id: 'sk_zone',
  name: 'SK (Slovakia Zone)',
  type: 'Market'
}, {
  id: 'hu_zone',
  name: 'HU (Hungary Zone)',
  type: 'Market'
}, {
  id: 'ro_zone',
  name: 'RO (Romania Zone)',
  type: 'Market'
}, {
  id: 'bg_zone',
  name: 'BG (Bulgaria Zone)',
  type: 'Market'
}, {
  id: 'gr_zone',
  name: 'GR (Greece Zone)',
  type: 'Market'
}, {
  id: 'hr_zone',
  name: 'HR (Croatia Zone)',
  type: 'Market'
}, {
  id: 'rs_zone',
  name: 'RS (Serbia Zone)',
  type: 'Market'
}, {
  id: 'si_zone',
  name: 'SI (Slovenia Zone)',
  type: 'Market'
}, {
  id: 'ie_sem',
  name: 'IE-SEM (Ireland)',
  type: 'Market'
}, {
  id: 'gb_zone',
  name: 'GB (Great Britain Zone)',
  type: 'Market'
},
// Countries
{
  id: 'de',
  name: 'Germany',
  type: 'Country'
}, {
  id: 'uk',
  name: 'United Kingdom',
  type: 'Country'
}, {
  id: 'fr',
  name: 'France',
  type: 'Country'
}, {
  id: 'es',
  name: 'Spain',
  type: 'Country'
}, {
  id: 'it',
  name: 'Italy',
  type: 'Country'
}, {
  id: 'nl',
  name: 'Netherlands',
  type: 'Country'
}, {
  id: 'pl',
  name: 'Poland',
  type: 'Country'
}, {
  id: 'se',
  name: 'Sweden',
  type: 'Country'
}, {
  id: 'no',
  name: 'Norway',
  type: 'Country'
}, {
  id: 'dk',
  name: 'Denmark',
  type: 'Country'
}, {
  id: 'fi',
  name: 'Finland',
  type: 'Country'
}, {
  id: 'at',
  name: 'Austria',
  type: 'Country'
}, {
  id: 'ch',
  name: 'Switzerland',
  type: 'Country'
}, {
  id: 'be',
  name: 'Belgium',
  type: 'Country'
}, {
  id: 'pt',
  name: 'Portugal',
  type: 'Country'
}, {
  id: 'ie',
  name: 'Ireland',
  type: 'Country'
}, {
  id: 'cz',
  name: 'Czech Republic',
  type: 'Country'
}, {
  id: 'ro',
  name: 'Romania',
  type: 'Country'
}, {
  id: 'hu',
  name: 'Hungary',
  type: 'Country'
}, {
  id: 'bg',
  name: 'Bulgaria',
  type: 'Country'
}, {
  id: 'hr',
  name: 'Croatia',
  type: 'Country'
}, {
  id: 'rs',
  name: 'Serbia',
  type: 'Country'
}, {
  id: 'gr',
  name: 'Greece',
  type: 'Country'
}, {
  id: 'sk',
  name: 'Slovakia',
  type: 'Country'
}, {
  id: 'si',
  name: 'Slovenia',
  type: 'Country'
}, {
  id: 'lt',
  name: 'Lithuania',
  type: 'Country'
}, {
  id: 'lv',
  name: 'Latvia',
  type: 'Country'
}, {
  id: 'ee',
  name: 'Estonia',
  type: 'Country'
}, {
  id: 'lu',
  name: 'Luxembourg',
  type: 'Country'
}, {
  id: 'berlin',
  name: 'Berlin',
  type: 'City',
  parentId: 'de'
}, {
  id: 'london',
  name: 'London',
  type: 'City',
  parentId: 'uk'
}, {
  id: 'paris',
  name: 'Paris',
  type: 'City',
  parentId: 'fr'
}, {
  id: 'madrid',
  name: 'Madrid',
  type: 'City',
  parentId: 'es'
}, {
  id: 'rome',
  name: 'Rome',
  type: 'City',
  parentId: 'it'
}, {
  id: 'amsterdam',
  name: 'Amsterdam',
  type: 'City',
  parentId: 'nl'
}, {
  id: 'warsaw',
  name: 'Warsaw',
  type: 'City',
  parentId: 'pl'
}, {
  id: 'stockholm',
  name: 'Stockholm',
  type: 'City',
  parentId: 'se'
}, {
  id: 'oslo',
  name: 'Oslo',
  type: 'City',
  parentId: 'no'
}, {
  id: 'munich',
  name: 'Munich',
  type: 'City',
  parentId: 'de'
}, {
  id: 'hamburg',
  name: 'Hamburg',
  type: 'City',
  parentId: 'de'
}, {
  id: 'copenhagen',
  name: 'Copenhagen',
  type: 'City',
  parentId: 'dk'
}, {
  id: 'helsinki',
  name: 'Helsinki',
  type: 'City',
  parentId: 'fi'
}, {
  id: 'vienna',
  name: 'Vienna',
  type: 'City',
  parentId: 'at'
}, {
  id: 'prague',
  name: 'Prague',
  type: 'City',
  parentId: 'cz'
}, {
  id: 'bucharest',
  name: 'Bucharest',
  type: 'City',
  parentId: 'ro'
}, {
  id: 'budapest',
  name: 'Budapest',
  type: 'City',
  parentId: 'hu'
}, {
  id: 'athens',
  name: 'Athens',
  type: 'City',
  parentId: 'gr'
}, {
  id: 'lisbon',
  name: 'Lisbon',
  type: 'City',
  parentId: 'pt'
}, {
  id: 'dublin',
  name: 'Dublin',
  type: 'City',
  parentId: 'ie'
}, {
  id: 'north_sea',
  name: 'North Sea',
  type: 'Offshore'
}, {
  id: 'baltic_sea',
  name: 'Baltic Sea',
  type: 'Offshore'
}, {
  id: 'mediterranean',
  name: 'Mediterranean',
  type: 'Offshore'
},
// POI — Weather Stations & Energy Assets
{
  id: 'poi_borkum',
  name: 'Borkum Weather Station',
  type: 'POI',
  parentId: 'de'
}, {
  id: 'poi_alpha_ventus',
  name: 'Alpha Ventus Wind Farm',
  type: 'POI',
  parentId: 'de'
}, {
  id: 'poi_horns_rev3',
  name: 'Horns Rev 3',
  type: 'POI',
  parentId: 'dk'
}, {
  id: 'poi_london_array',
  name: 'London Array',
  type: 'POI',
  parentId: 'uk'
}, {
  id: 'poi_borssele',
  name: 'Borssele Wind Farm',
  type: 'POI',
  parentId: 'nl'
}, {
  id: 'poi_hywind',
  name: 'Hywind Tampen',
  type: 'POI',
  parentId: 'no'
}, {
  id: 'poi_zugspitze',
  name: 'Zugspitze Weather Station',
  type: 'POI',
  parentId: 'de'
}, {
  id: 'poi_cabauw',
  name: 'Cabauw Observatory',
  type: 'POI',
  parentId: 'nl'
}, {
  id: 'poi_lindenberg',
  name: 'Lindenberg Observatory',
  type: 'POI',
  parentId: 'de'
}, {
  id: 'poi_sodankyla',
  name: 'Sodankylä Observatory',
  type: 'POI',
  parentId: 'fi'
}];
export const REGION_COORDS: Record<string, {
  lat: number;
  lng: number;
}> = {
  nordic: {
    lat: 62.0,
    lng: 15.0
  },
  iberia: {
    lat: 39.5,
    lng: -3.0
  },
  cee: {
    lat: 50.0,
    lng: 18.0
  },
  balkans: {
    lat: 42.5,
    lng: 21.0
  },
  benelux: {
    lat: 50.8,
    lng: 4.5
  },
  de_lu: {
    lat: 50.5,
    lng: 9.5
  },
  de_at_lu: {
    lat: 49.5,
    lng: 11.0
  },
  se1: {
    lat: 67.0,
    lng: 20.0
  },
  se2: {
    lat: 62.5,
    lng: 17.3
  },
  se3: {
    lat: 59.3,
    lng: 18.1
  },
  se4: {
    lat: 55.6,
    lng: 13.0
  },
  no1: {
    lat: 59.9,
    lng: 10.7
  },
  no2: {
    lat: 58.1,
    lng: 8.0
  },
  no3: {
    lat: 63.4,
    lng: 10.4
  },
  no4: {
    lat: 69.6,
    lng: 19.0
  },
  no5: {
    lat: 60.4,
    lng: 5.3
  },
  dk1: {
    lat: 56.2,
    lng: 9.0
  },
  dk2: {
    lat: 55.7,
    lng: 12.6
  },
  fi_zone: {
    lat: 61.5,
    lng: 24.0
  },
  ee_zone: {
    lat: 58.6,
    lng: 25.0
  },
  lv_zone: {
    lat: 56.9,
    lng: 24.1
  },
  lt_zone: {
    lat: 55.2,
    lng: 24.0
  },
  nl_zone: {
    lat: 52.1,
    lng: 5.3
  },
  be_zone: {
    lat: 50.5,
    lng: 4.4
  },
  fr_zone: {
    lat: 46.6,
    lng: 2.2
  },
  es_zone: {
    lat: 40.0,
    lng: -3.7
  },
  pt_zone: {
    lat: 39.4,
    lng: -8.2
  },
  it_north: {
    lat: 45.5,
    lng: 11.0
  },
  it_cnorth: {
    lat: 43.8,
    lng: 11.2
  },
  it_csouth: {
    lat: 41.9,
    lng: 13.5
  },
  it_south: {
    lat: 40.5,
    lng: 16.0
  },
  it_sicily: {
    lat: 37.5,
    lng: 14.0
  },
  it_sardinia: {
    lat: 40.0,
    lng: 9.0
  },
  at_zone: {
    lat: 47.5,
    lng: 14.5
  },
  ch_zone: {
    lat: 46.8,
    lng: 8.2
  },
  pl_zone: {
    lat: 52.0,
    lng: 19.4
  },
  cz_zone: {
    lat: 49.8,
    lng: 15.5
  },
  sk_zone: {
    lat: 48.7,
    lng: 19.7
  },
  hu_zone: {
    lat: 47.2,
    lng: 19.5
  },
  ro_zone: {
    lat: 45.9,
    lng: 25.0
  },
  bg_zone: {
    lat: 42.7,
    lng: 25.5
  },
  gr_zone: {
    lat: 39.1,
    lng: 21.8
  },
  hr_zone: {
    lat: 45.1,
    lng: 15.2
  },
  rs_zone: {
    lat: 44.0,
    lng: 21.0
  },
  si_zone: {
    lat: 46.1,
    lng: 14.8
  },
  ie_sem: {
    lat: 53.4,
    lng: -8.2
  },
  gb_zone: {
    lat: 54.0,
    lng: -2.0
  },
  de: {
    lat: 51.2,
    lng: 10.4
  },
  uk: {
    lat: 54.0,
    lng: -2.0
  },
  fr: {
    lat: 46.6,
    lng: 2.2
  },
  es: {
    lat: 40.0,
    lng: -3.7
  },
  it: {
    lat: 42.5,
    lng: 12.5
  },
  nl: {
    lat: 52.1,
    lng: 5.3
  },
  pl: {
    lat: 52.0,
    lng: 19.4
  },
  se: {
    lat: 62.0,
    lng: 15.0
  },
  no: {
    lat: 64.0,
    lng: 12.0
  },
  dk: {
    lat: 56.0,
    lng: 9.5
  },
  fi: {
    lat: 64.0,
    lng: 26.0
  },
  at: {
    lat: 47.5,
    lng: 14.5
  },
  ch: {
    lat: 46.8,
    lng: 8.2
  },
  be: {
    lat: 50.5,
    lng: 4.4
  },
  pt: {
    lat: 39.4,
    lng: -8.2
  },
  ie: {
    lat: 53.4,
    lng: -8.2
  },
  cz: {
    lat: 49.8,
    lng: 15.5
  },
  ro: {
    lat: 45.9,
    lng: 25.0
  },
  hu: {
    lat: 47.2,
    lng: 19.5
  },
  bg: {
    lat: 42.7,
    lng: 25.5
  },
  hr: {
    lat: 45.1,
    lng: 15.2
  },
  rs: {
    lat: 44.0,
    lng: 21.0
  },
  gr: {
    lat: 39.1,
    lng: 21.8
  },
  sk: {
    lat: 48.7,
    lng: 19.7
  },
  si: {
    lat: 46.1,
    lng: 14.8
  },
  lt: {
    lat: 55.2,
    lng: 24.0
  },
  lv: {
    lat: 56.9,
    lng: 24.1
  },
  ee: {
    lat: 58.6,
    lng: 25.0
  },
  lu: {
    lat: 49.8,
    lng: 6.1
  },
  berlin: {
    lat: 52.52,
    lng: 13.4
  },
  london: {
    lat: 51.5,
    lng: -0.12
  },
  paris: {
    lat: 48.86,
    lng: 2.35
  },
  madrid: {
    lat: 40.42,
    lng: -3.7
  },
  rome: {
    lat: 41.9,
    lng: 12.5
  },
  amsterdam: {
    lat: 52.37,
    lng: 4.9
  },
  warsaw: {
    lat: 52.23,
    lng: 21.0
  },
  stockholm: {
    lat: 59.33,
    lng: 18.07
  },
  oslo: {
    lat: 59.91,
    lng: 10.75
  },
  munich: {
    lat: 48.14,
    lng: 11.58
  },
  hamburg: {
    lat: 53.55,
    lng: 9.99
  },
  copenhagen: {
    lat: 55.68,
    lng: 12.57
  },
  helsinki: {
    lat: 60.17,
    lng: 24.94
  },
  vienna: {
    lat: 48.21,
    lng: 16.37
  },
  prague: {
    lat: 50.08,
    lng: 14.44
  },
  bucharest: {
    lat: 44.43,
    lng: 26.1
  },
  budapest: {
    lat: 47.5,
    lng: 19.04
  },
  athens: {
    lat: 37.98,
    lng: 23.73
  },
  lisbon: {
    lat: 38.72,
    lng: -9.14
  },
  dublin: {
    lat: 53.35,
    lng: -6.26
  },
  north_sea: {
    lat: 56.0,
    lng: 3.0
  },
  baltic_sea: {
    lat: 58.0,
    lng: 20.0
  },
  mediterranean: {
    lat: 38.0,
    lng: 15.0
  },
  poi_borkum: {
    lat: 53.59,
    lng: 6.66
  },
  poi_alpha_ventus: {
    lat: 54.01,
    lng: 6.59
  },
  poi_horns_rev3: {
    lat: 55.73,
    lng: 7.59
  },
  poi_london_array: {
    lat: 51.63,
    lng: 1.35
  },
  poi_borssele: {
    lat: 51.72,
    lng: 3.02
  },
  poi_hywind: {
    lat: 61.28,
    lng: 2.38
  },
  poi_zugspitze: {
    lat: 47.42,
    lng: 10.99
  },
  poi_cabauw: {
    lat: 51.97,
    lng: 4.93
  },
  poi_lindenberg: {
    lat: 52.21,
    lng: 14.12
  },
  poi_sodankyla: {
    lat: 67.37,
    lng: 26.63
  }
};
export const TYPE_COLORS: Record<string, string> = {
  Country: '#10b981',
  Market: '#3b82f6',
  City: '#f59e0b',
  Offshore: '#06b6d4',
  POI: '#f43f5e'
};
export const COUNTRY_REGIONS = REGIONS.filter(r => r.type === 'Country');
// Map GeoJSON country names to our region IDs
export const GEOJSON_NAME_TO_REGION: Record<string, string> = {
  Germany: 'de',
  'United Kingdom': 'uk',
  France: 'fr',
  Spain: 'es',
  Italy: 'it',
  Netherlands: 'nl',
  Poland: 'pl',
  Sweden: 'se',
  Norway: 'no',
  Denmark: 'dk',
  Finland: 'fi',
  Austria: 'at',
  Switzerland: 'ch',
  Belgium: 'be',
  Portugal: 'pt',
  Ireland: 'ie',
  Czechia: 'cz',
  'Czech Republic': 'cz',
  Romania: 'ro',
  Hungary: 'hu',
  Bulgaria: 'bg',
  Croatia: 'hr',
  Serbia: 'rs',
  Greece: 'gr',
  Slovakia: 'sk',
  Slovenia: 'si',
  Lithuania: 'lt',
  Latvia: 'lv',
  Estonia: 'ee',
  Luxembourg: 'lu',
  'Republic of Serbia': 'rs',
  'Bosnia and Herzegovina': 'ba',
  Montenegro: 'me',
  'North Macedonia': 'mk',
  Macedonia: 'mk',
  Albania: 'al',
  Moldova: 'md',
  Belarus: 'by',
  Ukraine: 'ua',
  Iceland: 'is'
};
function haversineDistance(lat1: number, lng1: number, lat2: number, lng2: number): number {
  const toRad = (v: number) => v * Math.PI / 180;
  const dLat = toRad(lat2 - lat1);
  const dLng = toRad(lng2 - lng1);
  const a = Math.sin(dLat / 2) ** 2 + Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) ** 2;
  return 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}
export function findNearestCountry(lat: number, lng: number): Region | null {
  let nearest: Region | null = null;
  let minDist = Infinity;
  for (const region of COUNTRY_REGIONS) {
    const coords = REGION_COORDS[region.id];
    if (!coords) continue;
    const dist = haversineDistance(lat, lng, coords.lat, coords.lng);
    if (dist < minDist) {
      minDist = dist;
      nearest = region;
    }
  }
  return nearest;
}
export function createZoneIcon(type: string, isSelected: boolean, isLight: boolean): L.DivIcon {
  const color = isSelected ? '#EC4899' : TYPE_COLORS[type] || '#94a3b8';
  const size = type === 'City' ? 7 : type === 'Market' ? 12 : type === 'POI' ? 10 : 9;
  const borderWidth = isSelected ? 2 : 1.5;
  const borderColor = isSelected ? '#fff' : isLight ? '#fff' : color + '60';
  const shadow = isSelected ? `0 0 6px ${color}80, 0 0 14px ${color}40` : `0 1px 3px rgba(0,0,0,${isLight ? '0.3' : '0.6'})`;
  const borderRadius = type === 'POI' ? '2px' : '50%';
  const transform = type === 'POI' ? 'rotate(45deg)' : 'none';
  const html = `<div style="width:${size}px;height:${size}px;border-radius:${borderRadius};background:${color};border:${borderWidth}px solid ${borderColor};box-shadow:${shadow};transition:all 0.2s;cursor:pointer;transform:${transform};"></div>`;
  return L.divIcon({
    html,
    className: '',
    iconSize: [size, size],
    iconAnchor: [size / 2, size / 2]
  });
}
export function MapInvalidator() {
  const map = useMap();
  useEffect(() => {
    const timer = setTimeout(() => map.invalidateSize(), 150);
    return () => clearTimeout(timer);
  }, [map]);
  return null;
}
export function MapFlyTo({
  target
}: {
  target: {
    lat: number;
    lng: number;
  } | null;
}) {
  const map = useMap();
  useEffect(() => {
    if (target) {
      map.flyTo([target.lat, target.lng], 5, {
        duration: 0.6
      });
    }
  }, [target, map]);
  return null;
}
// Shared flag to suppress map click when a marker was clicked
const markerClickedRef = {
  current: false
};
export function MapClickHandler({
  onClickLocation
}: {
  onClickLocation: (lat: number, lng: number) => void;
}) {
  const downPos = useRef<{
    x: number;
    y: number;
  } | null>(null);
  const map = useMap();
  // Set crosshair cursor on the map container
  useEffect(() => {
    const container = map.getContainer();
    container.style.cursor = 'crosshair';
    return () => {
      container.style.cursor = '';
    };
  }, [map]);
  useMapEvents({
    mousedown(e) {
      downPos.current = {
        x: e.originalEvent.clientX,
        y: e.originalEvent.clientY
      };
    },
    mouseup(e) {
      if (!downPos.current) return;
      // If a marker was just clicked, skip adding a new point
      if (markerClickedRef.current) {
        markerClickedRef.current = false;
        downPos.current = null;
        return;
      }
      const dx = e.originalEvent.clientX - downPos.current.x;
      const dy = e.originalEvent.clientY - downPos.current.y;
      const distance = Math.sqrt(dx * dx + dy * dy);
      // Only treat as a click if the mouse moved less than 5px (not a drag/pan)
      if (distance < 5) {
        onClickLocation(e.latlng.lat, e.latlng.lng);
      }
      downPos.current = null;
    }
  });
  return null;
}
export function CountryBoundaries({
  selectedId,
  isLight,
  onSelectRegion,
  boundaryType = 'Country'
}: {
  selectedId: string | null;
  isLight: boolean;
  onSelectRegion: (regionId: string) => void;
  boundaryType?: 'Country' | 'Market';
}) {
  const map = useMap();
  const layerRef = useRef<L.GeoJSON | null>(null);
  const hoveredRef = useRef<string | null>(null);
  const selectedRef = useRef<string | null>(selectedId);
  // Keep selectedRef in sync
  useEffect(() => {
    selectedRef.current = selectedId;
    // Re-style all layers when selection changes
    if (layerRef.current) {
      layerRef.current.eachLayer((layer: any) => {
        const regionId = layer.feature?.properties?._regionId;
        if (regionId) {
          const isSelected = regionId === selectedId;
          const isHovered = regionId === hoveredRef.current;
          layer.setStyle(getBoundaryStyle(isHovered, isSelected, isLight, boundaryType));
        }
      });
    }
  }, [selectedId, isLight]);
  useEffect(() => {
    let cancelled = false;
    fetch('https://raw.githubusercontent.com/leakyMirror/map-of-europe/master/GeoJSON/europe.geojson').then(res => {
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      return res.json();
    }).then(data => {
      if (cancelled) return;
      // Tag each feature with our regionId
      if (data.features) {
        data.features.forEach((feature: any) => {
          const name = feature.properties?.NAME || feature.properties?.name || feature.properties?.ADMIN || '';
          const regionId = GEOJSON_NAME_TO_REGION[name];
          feature.properties._regionId = regionId || null;
          feature.properties._name = name;
        });
      }
      const geoLayer = L.geoJSON(data, {
        style: (feature: any) => {
          const regionId = feature?.properties?._regionId;
          const isSelected = regionId === selectedRef.current;
          return getBoundaryStyle(false, isSelected, isLight, boundaryType);
        },
        onEachFeature: (feature: any, layer: any) => {
          const regionId = feature.properties?._regionId;
          const countryName = feature.properties?._name;
          layer.on({
            mouseover: () => {
              hoveredRef.current = regionId;
              layer.setStyle(getBoundaryStyle(true, regionId === selectedRef.current, isLight, boundaryType));
              layer.bringToFront();
              // Show tooltip
              if (countryName) {
                layer.bindTooltip(countryName, {
                  sticky: true,
                  className: 'country-tooltip',
                  direction: 'top',
                  offset: [0, -10]
                }).openTooltip();
              }
            },
            mouseout: () => {
              hoveredRef.current = null;
              layer.setStyle(getBoundaryStyle(false, regionId === selectedRef.current, isLight, boundaryType));
              layer.unbindTooltip();
            },
            click: () => {
              if (regionId) {
                onSelectRegion(regionId);
              }
            }
          });
        }
      });
      geoLayer.addTo(map);
      layerRef.current = geoLayer;
    }).catch(() => {
      // Silently fail — map still works with point markers
    });
    return () => {
      cancelled = true;
      if (layerRef.current) {
        map.removeLayer(layerRef.current);
        layerRef.current = null;
      }
    };
  }, [map, isLight]); // eslint-disable-line react-hooks/exhaustive-deps
  return null;
}
// Approximate market zone boundaries (simplified polygons)
const MARKET_ZONE_BOUNDARIES: Record<string, [number, number][]> = {
  // Sweden zones (north to south)
  se1: [[69.0, 18.0], [69.0, 24.0], [65.5, 24.0], [65.5, 18.0], [69.0, 18.0]],
  se2: [[65.5, 14.0], [65.5, 24.0], [61.5, 24.0], [61.5, 14.0], [65.5, 14.0]],
  se3: [[61.5, 11.0], [61.5, 24.0], [58.0, 24.0], [58.0, 11.0], [61.5, 11.0]],
  se4: [[58.0, 11.0], [58.0, 19.0], [55.3, 14.5], [55.3, 11.0], [58.0, 11.0]],
  // Norway zones
  no1: [[61.5, 4.5], [61.5, 12.0], [58.5, 12.0], [58.5, 4.5], [61.5, 4.5]],
  no2: [[61.5, 4.5], [58.5, 4.5], [58.5, 8.5], [56.5, 8.5], [56.5, 4.5], [61.5, 4.5]],
  no3: [[66.0, 8.0], [66.0, 14.0], [61.5, 14.0], [61.5, 8.0], [66.0, 8.0]],
  no4: [[71.0, 15.0], [71.0, 31.0], [66.0, 31.0], [66.0, 15.0], [71.0, 15.0]],
  no5: [[62.0, 4.0], [62.0, 8.0], [58.5, 8.0], [58.5, 4.0], [62.0, 4.0]],
  // Denmark zones
  dk1: [[57.8, 8.0], [57.8, 11.0], [54.5, 11.0], [54.5, 8.0], [57.8, 8.0]],
  dk2: [[56.5, 11.0], [56.5, 13.0], [54.5, 13.0], [54.5, 11.0], [56.5, 11.0]]
};
// Map country IDs to their market zone equivalents (for single-zone countries)
const COUNTRY_TO_MARKET_ZONE: Record<string, string> = {
  de: 'de_lu',
  fr: 'fr_zone',
  es: 'es_zone',
  pt: 'pt_zone',
  nl: 'nl_zone',
  be: 'be_zone',
  at: 'at_zone',
  ch: 'ch_zone',
  pl: 'pl_zone',
  cz: 'cz_zone',
  sk: 'sk_zone',
  hu: 'hu_zone',
  ro: 'ro_zone',
  bg: 'bg_zone',
  gr: 'gr_zone',
  hr: 'hr_zone',
  rs: 'rs_zone',
  si: 'si_zone',
  ie: 'ie_sem',
  uk: 'gb_zone',
  fi: 'fi_zone',
  ee: 'ee_zone',
  lv: 'lv_zone',
  lt: 'lt_zone'
};
// Countries with subdivided zones (don't show country boundary, only sub-zones)
const SUBDIVIDED_COUNTRIES = ['se', 'no', 'dk', 'it'];
export function MarketZoneBoundaries({
  selectedId,
  isLight,
  onSelectRegion
}: {
  selectedId: string | null;
  isLight: boolean;
  onSelectRegion: (regionId: string) => void;
}) {
  const map = useMap();
  const layerRef = useRef<L.GeoJSON | null>(null);
  const hoveredRef = useRef<string | null>(null);
  const selectedRef = useRef<string | null>(selectedId);
  const [hoveredZone, setHoveredZone] = useState<string | null>(null);
  // Keep selectedRef in sync
  useEffect(() => {
    selectedRef.current = selectedId;
    if (layerRef.current) {
      layerRef.current.eachLayer((layer: any) => {
        const marketZoneId = layer.feature?.properties?._marketZoneId;
        if (marketZoneId) {
          const isSelected = marketZoneId === selectedId;
          const isHovered = marketZoneId === hoveredRef.current;
          layer.setStyle(getBoundaryStyle(isHovered, isSelected, isLight, 'Market'));
        }
      });
    }
  }, [selectedId, isLight]);
  // Load country boundaries and convert to market zones
  useEffect(() => {
    let cancelled = false;
    fetch('https://raw.githubusercontent.com/leakyMirror/map-of-europe/master/GeoJSON/europe.geojson').then(res => {
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      return res.json();
    }).then(data => {
      if (cancelled) return;
      if (data.features) {
        data.features = data.features.filter((feature: any) => {
          const name = feature.properties?.NAME || feature.properties?.name || feature.properties?.ADMIN || '';
          const countryId = GEOJSON_NAME_TO_REGION[name];
          // Skip subdivided countries (they use custom polygons)
          if (countryId && SUBDIVIDED_COUNTRIES.includes(countryId)) {
            return false;
          }
          const marketZoneId = countryId ? COUNTRY_TO_MARKET_ZONE[countryId] : null;
          feature.properties._marketZoneId = marketZoneId;
          feature.properties._name = name;
          return marketZoneId;
        });
      }
      const geoLayer = L.geoJSON(data, {
        style: (feature: any) => {
          const marketZoneId = feature?.properties?._marketZoneId;
          const isSelected = marketZoneId === selectedRef.current;
          return getBoundaryStyle(false, isSelected, isLight, 'Market');
        },
        onEachFeature: (feature: any, layer: any) => {
          const marketZoneId = feature.properties?._marketZoneId;
          const countryName = feature.properties?._name;
          layer.on({
            mouseover: () => {
              hoveredRef.current = marketZoneId;
              layer.setStyle(getBoundaryStyle(true, marketZoneId === selectedRef.current, isLight, 'Market'));
              layer.bringToFront();
              if (countryName) {
                layer.bindTooltip(countryName, {
                  sticky: true,
                  className: 'country-tooltip',
                  direction: 'top',
                  offset: [0, -10]
                }).openTooltip();
              }
            },
            mouseout: () => {
              hoveredRef.current = null;
              layer.setStyle(getBoundaryStyle(false, marketZoneId === selectedRef.current, isLight, 'Market'));
              layer.unbindTooltip();
            },
            click: () => {
              if (marketZoneId) {
                onSelectRegion(marketZoneId);
              }
            }
          });
        }
      });
      geoLayer.addTo(map);
      layerRef.current = geoLayer;
    }).catch(() => {});
    return () => {
      cancelled = true;
      if (layerRef.current) {
        map.removeLayer(layerRef.current);
        layerRef.current = null;
      }
    };
  }, [map, isLight, onSelectRegion]);
  return <>
      {Object.entries(MARKET_ZONE_BOUNDARIES).map(([zoneId, coordinates]) => {
      const isSelected = selectedId === zoneId;
      const isHovered = hoveredZone === zoneId;
      return <Polygon key={zoneId} positions={coordinates as [number, number][]} pathOptions={getBoundaryStyle(isHovered, isSelected, isLight, 'Market')} eventHandlers={{
        mouseover: () => setHoveredZone(zoneId),
        mouseout: () => setHoveredZone(null),
        click: () => onSelectRegion(zoneId)
      }} data-id="element-1761" />;
    })}
    </>;
}
export function getBoundaryStyle(isHovered: boolean, isSelected: boolean, isLight: boolean, boundaryType: 'Country' | 'Market' = 'Country'): L.PathOptions {
  // Market zones use blue, countries use pink
  const baseColor = boundaryType === 'Market' ? '#3b82f6' : '#EC4899';
  if (isSelected) {
    return {
      fillColor: baseColor,
      fillOpacity: isLight ? 0.2 : 0.25,
      color: baseColor,
      weight: 1.5,
      opacity: 0.7
    };
  }
  if (isHovered) {
    return {
      fillColor: baseColor,
      fillOpacity: isLight ? 0.12 : 0.18,
      color: baseColor,
      weight: 1,
      opacity: 0.5
    };
  }
  return {
    fillColor: 'transparent',
    fillOpacity: 0,
    color: isLight ? 'rgba(0,0,0,0.08)' : 'rgba(255,255,255,0.08)',
    weight: 0.5,
    opacity: 1
  };
}
export interface MarketZoneSelection {
  regionId: string;
  regionName: string;
  regionType: string;
}
interface MarketZoneMapProps {
  onSelect: (selection: MarketZoneSelection | null) => void;
  defaultRegionId?: string;
  isLight: boolean;
}
export function MarketZoneMap({
  onSelect,
  defaultRegionId = 'de',
  isLight
}: MarketZoneMapProps) {
  const [selected, setSelected] = useState<Region | null>(() => defaultRegionId ? REGIONS.find(r => r.id === defaultRegionId) || null : null);
  const [activeTab, setActiveTab] = useState<'map' | 'list'>('map');
  const [forecastMode, setForecastMode] = useState<'regional' | 'point'>('regional');
  const [activeType, setActiveType] = useState<string>('Country');
  const [search, setSearch] = useState('');
  const [searchOpen, setSearchOpen] = useState(false);
  const searchRef = useRef<HTMLInputElement>(null);
  const [selectedPoints, setSelectedPoints] = useState<{
    lat: number;
    lng: number;
  }[]>([]);
  const [areaVertices, setAreaVertices] = useState<{
    lat: number;
    lng: number;
  }[]>([]);
  // Weighting state
  const WEIGHTING_OPTIONS = ['Capacity weighted', 'Population weighted', 'Equal weighted'] as const;
  type WeightingOption = (typeof WEIGHTING_OPTIONS)[number];
  const [weighting, setWeighting] = useState<WeightingOption>('Capacity weighted');
  const [weightingOpen, setWeightingOpen] = useState(false);
  const weightingRef = useRef<HTMLButtonElement>(null);
  const weightingDropdownRef = useRef<HTMLDivElement>(null);
  // Type dropdown state
  const [typeDropdownOpen, setTypeDropdownOpen] = useState(false);
  const typeDropdownRef = useRef<HTMLDivElement>(null);
  const typeChipRef = useRef<HTMLButtonElement>(null);
  // Close weighting dropdown on outside click
  useEffect(() => {
    if (!weightingOpen) return;
    const handler = (e: MouseEvent) => {
      const target = e.target as Node;
      if (weightingRef.current && !weightingRef.current.contains(target) && (!weightingDropdownRef.current || !weightingDropdownRef.current.contains(target))) {
        setWeightingOpen(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [weightingOpen]);
  // Close type dropdown on outside click
  useEffect(() => {
    if (!typeDropdownOpen) return;
    const handler = (e: MouseEvent) => {
      const target = e.target as Node;
      if (typeChipRef.current && !typeChipRef.current.contains(target) && (!typeDropdownRef.current || !typeDropdownRef.current.contains(target))) {
        setTypeDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [typeDropdownOpen]);
  useEffect(() => {
    if (activeTab === 'list' && searchRef.current) {
      setTimeout(() => searchRef.current?.focus(), 80);
    }
  }, [activeTab]);
  const handleSelectRegion = useCallback((region: Region) => {
    setSelected(region);
    onSelect({
      regionId: region.id,
      regionName: region.name,
      regionType: region.type
    });
    setActiveTab('map');
  }, [onSelect]);
  const handleMapClick = useCallback((lat: number, lng: number) => {
    const nearest = findNearestCountry(lat, lng);
    if (nearest) {
      handleSelectRegion(nearest);
    }
  }, [handleSelectRegion]);
  const handlePointClick = useCallback((lat: number, lng: number) => {
    setSelectedPoints(prev => [...prev, {
      lat,
      lng
    }]);
  }, []);
  const removePoint = useCallback((index: number) => {
    setSelectedPoints(prev => prev.filter((_, i) => i !== index));
  }, []);
  const handleAreaClick = useCallback((lat: number, lng: number) => {
    setAreaVertices(prev => [...prev, {
      lat,
      lng
    }]);
  }, []);
  const removeAreaVertex = useCallback((index: number) => {
    setAreaVertices(prev => prev.filter((_, i) => i !== index));
  }, []);
  const handleClear = useCallback(() => {
    setSelected(null);
    onSelect(null);
  }, [onSelect]);
  const handleBoundarySelect = useCallback((regionId: string) => {
    const region = REGIONS.find(r => r.id === regionId);
    if (region) {
      handleSelectRegion(region);
    }
  }, [handleSelectRegion]);
  useEffect(() => {
    if (selected) {
      onSelect({
        regionId: selected.id,
        regionName: selected.name,
        regionType: selected.type
      });
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const flyTarget = useMemo(() => {
    if (selected && REGION_COORDS[selected.id]) {
      return REGION_COORDS[selected.id];
    }
    return null;
  }, [selected]);
  const typeCounts = useMemo(() => {
    const counts: Record<string, number> = {};
    REGIONS.forEach(r => {
      counts[r.type] = (counts[r.type] || 0) + 1;
    });
    return counts;
  }, []);
  const mapRegions = useMemo(() => {
    return REGIONS.filter(r => r.type === activeType).filter(r => REGION_COORDS[r.id]);
  }, [activeType]);
  const filteredRegions = useMemo(() => {
    let filtered = REGIONS.filter(r => r.type === activeType);
    if (search) {
      const lower = search.toLowerCase();
      filtered = filtered.filter(r => r.name.toLowerCase().includes(lower));
    }
    return filtered;
  }, [search, activeType]);
  const getIconElement = (type: string) => {
    switch (type) {
      case 'Market':
        return <Globe size={13} data-id="element-1762" />;
      case 'Country':
        return <Globe size={13} data-id="element-1763" />;
      case 'City':
        return <Building2 size={13} data-id="element-1764" />;
      case 'Offshore':
        return <Waves size={13} data-id="element-1765" />;
      case 'POI':
        return <Radio size={13} data-id="element-1766" />;
      case 'Point':
        return <MapPin size={13} data-id="element-1767" />;
      case 'Area':
        return <MapIcon size={13} data-id="element-1768" />;
      default:
        return <Globe size={13} data-id="element-1769" />;
    }
  };
  const getIconForType = (type: string) => {
    const iconColor = isLight ? '#64748b' : '#94a3b8';
    return <div className="flex items-center justify-center w-6 h-6 rounded-md flex-shrink-0" style={{
      backgroundColor: isLight ? 'rgba(0,0,0,0.04)' : 'rgba(255,255,255,0.06)',
      border: `1px solid ${isLight ? 'rgba(0,0,0,0.06)' : 'rgba(255,255,255,0.06)'}`,
      color: iconColor
    }} data-id="element-1770">
        {getIconElement(type)}
      </div>;
  };
  const tileUrl = isLight ? 'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png' : 'https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png';
  const TYPE_LABELS: Record<string, string> = {
    Country: 'Country',
    Market: 'Market Zone',
    Area: 'Area',
    Point: 'Point',
    City: 'City',
    POI: 'POI'
  };
  const handleTypeSelect = (type: string) => {
    const isRegional = type === 'Country' || type === 'Market' || type === 'Area';
    const newMode = isRegional ? 'regional' : 'point';
    if (forecastMode !== newMode) {
      setForecastMode(newMode);
    }
    setActiveType(type);
    setTypeDropdownOpen(false);
    setWeightingOpen(false);
  };
  const handleForecastModeChange = (mode: 'regional' | 'point') => {
    setForecastMode(mode);
    setActiveType(mode === 'regional' ? 'Country' : 'Point');
    setWeightingOpen(false);
  };
  return <div className="flex flex-col h-full rounded-xl overflow-hidden border shadow-sm" style={{
    backgroundColor: isLight ? '#ffffff' : 'rgba(15, 23, 42, 0.95)',
    borderColor: isLight ? 'rgba(0,0,0,0.08)' : 'rgba(255,255,255,0.08)'
  }} data-id="element-1771">
      {/* Header */}
      <div className="flex items-center px-3 py-2 border-b" style={{
      borderColor: isLight ? 'rgba(0,0,0,0.06)' : 'rgba(255,255,255,0.06)'
    }} data-id="element-1772">
        <span className="text-xs font-semibold" style={{
        color: isLight ? '#0f172a' : '#f8fafc'
      }} data-id="element-1773">
          Location
        </span>
      </div>

      {/* Map Content */}
      <div className="flex-1 min-h-0 overflow-hidden relative" data-id="element-1774">
        {activeType === 'Point' || activeType === 'Area' ? <div className="h-full w-full relative" data-id="element-1775">
            <MapContainer center={[50, 10]} zoom={4} className="h-full w-full" zoomControl={false} attributionControl={false} style={{
          background: isLight ? '#e2e8f0' : '#0a1628',
          cursor: 'crosshair'
        }} data-id="element-1776">
              <TileLayer url={tileUrl} data-id="element-1777" />
              <ZoomControl position="bottomright" data-id="element-1778" />
              <MapInvalidator data-id="element-1779" />
              <MapClickHandler onClickLocation={activeType === 'Point' ? handlePointClick : handleAreaClick} data-id="element-1780" />
              {activeType === 'Point' && selectedPoints.map((pt, i) => <CircleMarker key={`pt-${i}`} center={[pt.lat, pt.lng]} radius={8} pathOptions={{
            color: '#ffffff',
            fillColor: '#EC4899',
            fillOpacity: 0.9,
            weight: 2.5,
            className: 'cursor-pointer'
          }} interactive={true} bubblingMouseEvents={false} eventHandlers={{
            click: e => {
              L.DomEvent.stopPropagation(e);
              markerClickedRef.current = true;
              removePoint(i);
            }
          }} data-id="element-1781" />)}
              {activeType === 'Area' && areaVertices.length >= 2 && <Polyline positions={areaVertices.map(v => [v.lat, v.lng])} pathOptions={{
            color: '#3b82f6',
            weight: 2,
            dashArray: '6 4',
            opacity: 0.7
          }} data-id="element-1782" />}
              {activeType === 'Area' && areaVertices.length >= 3 && <Polygon positions={areaVertices.map(v => [v.lat, v.lng])} pathOptions={{
            color: '#3b82f6',
            fillColor: '#3b82f6',
            fillOpacity: 0.12,
            weight: 2
          }} interactive={false} data-id="element-1783" />}
              {activeType === 'Area' && areaVertices.map((v, i) => <CircleMarker key={`av-${i}`} center={[v.lat, v.lng]} radius={7} pathOptions={{
            color: '#3b82f6',
            fillColor: '#ffffff',
            fillOpacity: 1,
            weight: 2.5,
            className: 'cursor-pointer'
          }} interactive={true} bubblingMouseEvents={false} eventHandlers={{
            click: e => {
              L.DomEvent.stopPropagation(e);
              markerClickedRef.current = true;
              removeAreaVertex(i);
            }
          }} data-id="element-1784" />)}
            </MapContainer>
            {/* Floating info + clear for Point/Area */}
            <div className="absolute bottom-2 left-2 right-2 z-[1000] flex items-center justify-between rounded-lg px-3 py-2" style={{
          background: isLight ? 'rgba(255,255,255,0.92)' : 'rgba(15,23,42,0.92)',
          backdropFilter: 'blur(8px)',
          border: `1px solid ${isLight ? 'rgba(0,0,0,0.08)' : 'rgba(255,255,255,0.08)'}`
        }} data-id="element-1785">
              <span className="text-[11px] font-medium" style={{
            color: isLight ? '#64748b' : '#94a3b8'
          }} data-id="element-1786">
                {activeType === 'Point' ? `${selectedPoints.length} point${selectedPoints.length !== 1 ? 's' : ''} selected · Click to add, click marker to remove` : `${areaVertices.length} vertices · Click to add, click vertex to remove`}
              </span>
              <button onClick={() => activeType === 'Point' ? setSelectedPoints([]) : setAreaVertices([])} className="text-[10px] font-medium px-2 py-0.5 rounded transition-colors" style={{
            color: '#EC4899',
            backgroundColor: 'rgba(236,72,153,0.1)'
          }} data-id="element-1787">
                Clear
              </button>
            </div>

            {/* Type Selector Chip — overlaid on map top-left */}
            <div className="absolute top-2.5 left-2.5 z-[1000]" data-id="element-1788">
              <button ref={typeChipRef} onClick={() => setTypeDropdownOpen(v => !v)} className="flex items-center gap-1.5 h-7 px-3 rounded-lg text-[11px] font-semibold transition-all shadow-md" style={{
            backgroundColor: isLight ? 'rgba(255,255,255,0.92)' : 'rgba(15,23,42,0.92)',
            backdropFilter: 'blur(12px)',
            WebkitBackdropFilter: 'blur(12px)',
            border: `1px solid ${isLight ? 'rgba(0,0,0,0.1)' : 'rgba(255,255,255,0.1)'}`,
            color: isLight ? '#0f172a' : '#f1f5f9'
          }} data-id="element-1789">
                {TYPE_LABELS[activeType] || activeType}
                <ChevronDown size={11} className={`transition-transform ${typeDropdownOpen ? 'rotate-180' : ''}`} style={{
              color: isLight ? '#64748b' : '#94a3b8'
            }} data-id="element-1790" />
              </button>

              {/* Type Dropdown */}
              {typeDropdownOpen && <div ref={typeDropdownRef} className="absolute top-full left-0 mt-1.5 w-52 rounded-xl border py-1 shadow-xl z-[1001] backdrop-blur-xl max-h-[280px] overflow-y-auto" style={{
            backgroundColor: isLight ? 'rgba(255,255,255,0.65)' : 'rgba(15,23,42,0.55)',
            borderColor: isLight ? 'rgba(255,255,255,0.6)' : 'rgba(255,255,255,0.12)',
            boxShadow: isLight ? '0 8px 32px rgba(0,0,0,0.12), inset 0 1px 0 rgba(255,255,255,0.6)' : '0 8px 32px rgba(0,0,0,0.5), inset 0 1px 0 rgba(255,255,255,0.06)'
          }} data-id="element-1791">
                  {/* Regional Section */}
                  <div className="px-2.5 pt-1.5 pb-1 text-[9px] font-semibold uppercase tracking-wider" style={{
              color: isLight ? '#94a3b8' : '#475569'
            }} data-id="element-1792">
                    Regional
                  </div>
                  {['Country', 'Market', 'Area'].map(type => <button key={type} onClick={() => handleTypeSelect(type)} className="w-full text-left px-2.5 py-1.5 text-[11px] font-medium transition-colors flex items-center justify-between" style={{
              color: activeType === type ? '#EC4899' : isLight ? '#334155' : '#e2e8f0',
              backgroundColor: activeType === type ? isLight ? 'rgba(236,72,153,0.06)' : 'rgba(236,72,153,0.1)' : 'transparent'
            }} onMouseEnter={e => {
              if (activeType !== type) {
                e.currentTarget.style.backgroundColor = isLight ? 'rgba(0,0,0,0.04)' : 'rgba(255,255,255,0.06)';
              }
            }} onMouseLeave={e => {
              if (activeType !== type) {
                e.currentTarget.style.backgroundColor = 'transparent';
              }
            }} data-id="element-1793">
                      <div className="flex items-center gap-2" data-id="element-1794">
                        {getIconForType(type)}
                        <span data-id="element-1795">{TYPE_LABELS[type]}</span>
                      </div>
                      {activeType === type && <Check size={12} className="text-[#EC4899] flex-shrink-0" data-id="element-1796" />}
                    </button>)}

                  {/* Weighting row */}
                  {forecastMode === 'regional' && <div className="mx-2 mt-1 mb-0.5 px-2 py-1.5 rounded-md flex items-center justify-between" style={{
              backgroundColor: isLight ? 'rgba(0,0,0,0.03)' : 'rgba(255,255,255,0.04)'
            }} data-id="element-1797">
                      <span className="text-[10px] font-medium" style={{
                color: isLight ? '#64748b' : '#94a3b8'
              }} data-id="element-1798">
                        Weighting
                      </span>
                      <button onClick={e => {
                e.stopPropagation();
                setWeightingOpen(v => !v);
              }} className="flex items-center gap-1 text-[10px] font-semibold rounded px-1.5 py-0.5 transition-colors" style={{
                color: weightingOpen ? '#EC4899' : isLight ? '#0f172a' : '#f1f5f9',
                backgroundColor: weightingOpen ? isLight ? 'rgba(236,72,153,0.08)' : 'rgba(236,72,153,0.12)' : isLight ? 'rgba(0,0,0,0.05)' : 'rgba(255,255,255,0.08)'
              }} data-id="element-1799">
                        {weighting.replace(' weighted', '')}
                        <ChevronDown size={9} className={`transition-transform ${weightingOpen ? 'rotate-180' : ''}`} data-id="element-1800" />
                      </button>
                    </div>}

                  {/* Weighting sub-dropdown */}
                  {weightingOpen && forecastMode === 'regional' && <div className="mx-2 mb-1 rounded-md border overflow-hidden" style={{
              borderColor: isLight ? 'rgba(0,0,0,0.06)' : 'rgba(255,255,255,0.06)'
            }} data-id="element-1801">
                      {WEIGHTING_OPTIONS.map(opt => <button key={opt} onClick={e => {
                e.stopPropagation();
                setWeighting(opt);
                setWeightingOpen(false);
              }} className="w-full text-left px-2.5 py-1.5 text-[10px] transition-colors flex items-center justify-between" style={{
                color: opt === weighting ? '#EC4899' : isLight ? '#334155' : '#e2e8f0',
                backgroundColor: opt === weighting ? isLight ? 'rgba(236,72,153,0.06)' : 'rgba(236,72,153,0.1)' : 'transparent'
              }} onMouseEnter={e => {
                if (opt !== weighting) {
                  e.currentTarget.style.backgroundColor = isLight ? 'rgba(0,0,0,0.04)' : 'rgba(255,255,255,0.06)';
                }
              }} onMouseLeave={e => {
                if (opt !== weighting) {
                  e.currentTarget.style.backgroundColor = 'transparent';
                }
              }} data-id="element-1802">
                          <span data-id="element-1803">{opt}</span>
                          {opt === weighting && <Check size={10} className="text-[#EC4899] flex-shrink-0" data-id="element-1804" />}
                        </button>)}
                    </div>}

                  {/* Divider */}
                  <div className="my-1 mx-2" style={{
              borderTop: `1px solid ${isLight ? 'rgba(0,0,0,0.06)' : 'rgba(255,255,255,0.06)'}`
            }} data-id="element-1805" />

                  {/* Point Section */}
                  <div className="px-2.5 pt-1 pb-1 text-[9px] font-semibold uppercase tracking-wider" style={{
              color: isLight ? '#94a3b8' : '#475569'
            }} data-id="element-1806">
                    Point
                  </div>
                  {['Point', 'City', 'POI'].map(type => <button key={type} onClick={() => handleTypeSelect(type)} className="w-full text-left px-2.5 py-1.5 text-[11px] font-medium transition-colors flex items-center justify-between" style={{
              color: activeType === type ? '#EC4899' : isLight ? '#334155' : '#e2e8f0',
              backgroundColor: activeType === type ? isLight ? 'rgba(236,72,153,0.06)' : 'rgba(236,72,153,0.1)' : 'transparent'
            }} onMouseEnter={e => {
              if (activeType !== type) {
                e.currentTarget.style.backgroundColor = isLight ? 'rgba(0,0,0,0.04)' : 'rgba(255,255,255,0.06)';
              }
            }} onMouseLeave={e => {
              if (activeType !== type) {
                e.currentTarget.style.backgroundColor = 'transparent';
              }
            }} data-id="element-1807">
                      <div className="flex items-center gap-2" data-id="element-1808">
                        {getIconForType(type)}
                        <span data-id="element-1809">{TYPE_LABELS[type]}</span>
                      </div>
                      {activeType === type && <Check size={12} className="text-[#EC4899] flex-shrink-0" data-id="element-1810" />}
                    </button>)}
                </div>}
            </div>
          </div> : <div className="h-full w-full relative" data-id="element-1811">
            <MapContainer center={[50, 10]} zoom={4} className="h-full w-full" zoomControl={false} attributionControl={false} style={{
          background: isLight ? '#e2e8f0' : '#0a1628'
        }} data-id="element-1812">
              <TileLayer url={tileUrl} data-id="element-1813" />
              <ZoomControl position="bottomright" data-id="element-1814" />
              <MapInvalidator data-id="element-1815" />
              <MapFlyTo target={flyTarget} data-id="element-1816" />
              {(activeType === 'Country' || activeType === 'Market') && <MapClickHandler onClickLocation={handleMapClick} data-id="element-1817" />}
              {activeType === 'Market' ? <MarketZoneBoundaries selectedId={selected?.id || null} isLight={isLight} onSelectRegion={handleBoundarySelect} data-id="element-1818" /> : activeType === 'Country' ? <CountryBoundaries selectedId={selected?.id || null} isLight={isLight} onSelectRegion={handleBoundarySelect} boundaryType="Country" data-id="element-1819" /> : null}
              {mapRegions.filter(region => {
            if (activeType === 'Market' && region.type === 'Market') return false;
            if (activeType === 'Country' && region.type === 'Country') return false;
            return true;
          }).map(region => {
            const coords = REGION_COORDS[region.id];
            if (!coords) return null;
            const isRegionSelected = selected?.id === region.id;
            return <Marker key={region.id} position={[coords.lat, coords.lng]} icon={createZoneIcon(region.type, isRegionSelected, isLight)} eventHandlers={{
              click: () => handleSelectRegion(region)
            }} data-id="element-1820" />;
          })}
            </MapContainer>

            {/* Search results overlay on map area */}
            {searchOpen && <div className="absolute inset-0 z-[1000] overflow-y-auto" style={{
          backgroundColor: isLight ? 'rgba(255,255,255,0.97)' : 'rgba(15,23,42,0.97)',
          backdropFilter: 'blur(16px)',
          WebkitBackdropFilter: 'blur(16px)'
        }} data-id="element-1821">
                {filteredRegions.length === 0 ? <div className="px-3 py-8 text-center text-[11px]" style={{
            color: isLight ? '#94a3b8' : '#64748b'
          }} data-id="element-1822">
                    No results found
                  </div> : filteredRegions.map(region => {
            const isRegionSelected = selected?.id === region.id;
            return <button key={region.id} onClick={() => {
              handleSelectRegion(region);
              setSearch('');
              setSearchOpen(false);
            }} className="w-full flex items-center justify-between px-3 py-2 text-left transition-colors" style={{
              backgroundColor: isRegionSelected ? isLight ? 'rgba(0,0,0,0.05)' : 'rgba(255,255,255,0.08)' : 'transparent'
            }} onMouseEnter={e => {
              if (!isRegionSelected) {
                e.currentTarget.style.backgroundColor = isLight ? 'rgba(0,0,0,0.03)' : 'rgba(255,255,255,0.04)';
              }
            }} onMouseLeave={e => {
              if (!isRegionSelected) {
                e.currentTarget.style.backgroundColor = 'transparent';
              }
            }} data-id="element-1823">
                        <div className="flex items-center gap-2 min-w-0" data-id="element-1824">
                          {getIconForType(region.type)}
                          <span className="text-[11px] font-medium truncate" style={{
                  color: isLight ? '#0f172a' : '#f8fafc'
                }} data-id="element-1825">
                            {region.name}
                          </span>
                          {region.parentId && <span className="text-[9px] truncate" style={{
                  color: isLight ? '#94a3b8' : '#64748b'
                }} data-id="element-1826">
                              {REGIONS.find(r => r.id === region.parentId)?.name}
                            </span>}
                        </div>
                        {isRegionSelected && <Check size={12} className="flex-shrink-0 ml-1" style={{
                color: isLight ? '#0f172a' : '#f8fafc'
              }} data-id="element-1827" />}
                      </button>;
          })}
              </div>}

            {/* Type Selector Chip — overlaid on map top-left */}
            <div className="absolute top-2.5 left-2.5 z-[1000]" data-id="element-1828">
              <button ref={typeChipRef} onClick={() => setTypeDropdownOpen(v => !v)} className="flex items-center gap-1.5 h-7 px-3 rounded-lg text-[11px] font-semibold transition-all shadow-md" style={{
            backgroundColor: isLight ? 'rgba(255,255,255,0.92)' : 'rgba(15,23,42,0.92)',
            backdropFilter: 'blur(12px)',
            WebkitBackdropFilter: 'blur(12px)',
            border: `1px solid ${isLight ? 'rgba(0,0,0,0.1)' : 'rgba(255,255,255,0.1)'}`,
            color: isLight ? '#0f172a' : '#f1f5f9'
          }} data-id="element-1829">
                {TYPE_LABELS[activeType] || activeType}
                <ChevronDown size={11} className={`transition-transform ${typeDropdownOpen ? 'rotate-180' : ''}`} style={{
              color: isLight ? '#64748b' : '#94a3b8'
            }} data-id="element-1830" />
              </button>

              {/* Type Dropdown */}
              {typeDropdownOpen && <div ref={typeDropdownRef} className="absolute top-full left-0 mt-1.5 w-52 rounded-xl border py-1 shadow-xl z-[1001] backdrop-blur-xl max-h-[280px] overflow-y-auto" style={{
            backgroundColor: isLight ? 'rgba(255,255,255,0.65)' : 'rgba(15,23,42,0.55)',
            borderColor: isLight ? 'rgba(255,255,255,0.6)' : 'rgba(255,255,255,0.12)',
            boxShadow: isLight ? '0 8px 32px rgba(0,0,0,0.12), inset 0 1px 0 rgba(255,255,255,0.6)' : '0 8px 32px rgba(0,0,0,0.5), inset 0 1px 0 rgba(255,255,255,0.06)'
          }} data-id="element-1831">
                  {/* Regional Section */}
                  <div className="px-2.5 pt-1.5 pb-1 text-[9px] font-semibold uppercase tracking-wider" style={{
              color: isLight ? '#94a3b8' : '#475569'
            }} data-id="element-1832">
                    Regional
                  </div>
                  {['Country', 'Market', 'Area'].map(type => <button key={type} onClick={() => handleTypeSelect(type)} className="w-full text-left px-2.5 py-1.5 text-[11px] font-medium transition-colors flex items-center justify-between" style={{
              color: activeType === type ? '#EC4899' : isLight ? '#334155' : '#e2e8f0',
              backgroundColor: activeType === type ? isLight ? 'rgba(236,72,153,0.06)' : 'rgba(236,72,153,0.1)' : 'transparent'
            }} onMouseEnter={e => {
              if (activeType !== type) {
                e.currentTarget.style.backgroundColor = isLight ? 'rgba(0,0,0,0.04)' : 'rgba(255,255,255,0.06)';
              }
            }} onMouseLeave={e => {
              if (activeType !== type) {
                e.currentTarget.style.backgroundColor = 'transparent';
              }
            }} data-id="element-1833">
                      <div className="flex items-center gap-2" data-id="element-1834">
                        {getIconForType(type)}
                        <span data-id="element-1835">{TYPE_LABELS[type]}</span>
                      </div>
                      {activeType === type && <Check size={12} className="text-[#EC4899] flex-shrink-0" data-id="element-1836" />}
                    </button>)}

                  {/* Weighting row */}
                  {forecastMode === 'regional' && <div className="mx-2 mt-1 mb-0.5 px-2 py-1.5 rounded-md flex items-center justify-between" style={{
              backgroundColor: isLight ? 'rgba(0,0,0,0.03)' : 'rgba(255,255,255,0.04)'
            }} data-id="element-1837">
                      <span className="text-[10px] font-medium" style={{
                color: isLight ? '#64748b' : '#94a3b8'
              }} data-id="element-1838">
                        Weighting
                      </span>
                      <button onClick={e => {
                e.stopPropagation();
                setWeightingOpen(v => !v);
              }} className="flex items-center gap-1 text-[10px] font-semibold rounded px-1.5 py-0.5 transition-colors" style={{
                color: weightingOpen ? '#EC4899' : isLight ? '#0f172a' : '#f1f5f9',
                backgroundColor: weightingOpen ? isLight ? 'rgba(236,72,153,0.08)' : 'rgba(236,72,153,0.12)' : isLight ? 'rgba(0,0,0,0.05)' : 'rgba(255,255,255,0.08)'
              }} data-id="element-1839">
                        {weighting.replace(' weighted', '')}
                        <ChevronDown size={9} className={`transition-transform ${weightingOpen ? 'rotate-180' : ''}`} data-id="element-1840" />
                      </button>
                    </div>}

                  {/* Weighting sub-dropdown */}
                  {weightingOpen && forecastMode === 'regional' && <div className="mx-2 mb-1 rounded-md border overflow-hidden" style={{
              borderColor: isLight ? 'rgba(0,0,0,0.06)' : 'rgba(255,255,255,0.06)'
            }} data-id="element-1841">
                      {WEIGHTING_OPTIONS.map(opt => <button key={opt} onClick={e => {
                e.stopPropagation();
                setWeighting(opt);
                setWeightingOpen(false);
              }} className="w-full text-left px-2.5 py-1.5 text-[10px] transition-colors flex items-center justify-between" style={{
                color: opt === weighting ? '#EC4899' : isLight ? '#334155' : '#e2e8f0',
                backgroundColor: opt === weighting ? isLight ? 'rgba(236,72,153,0.06)' : 'rgba(236,72,153,0.1)' : 'transparent'
              }} onMouseEnter={e => {
                if (opt !== weighting) {
                  e.currentTarget.style.backgroundColor = isLight ? 'rgba(0,0,0,0.04)' : 'rgba(255,255,255,0.06)';
                }
              }} onMouseLeave={e => {
                if (opt !== weighting) {
                  e.currentTarget.style.backgroundColor = 'transparent';
                }
              }} data-id="element-1842">
                          <span data-id="element-1843">{opt}</span>
                          {opt === weighting && <Check size={10} className="text-[#EC4899] flex-shrink-0" data-id="element-1844" />}
                        </button>)}
                    </div>}

                  {/* Divider */}
                  <div className="my-1 mx-2" style={{
              borderTop: `1px solid ${isLight ? 'rgba(0,0,0,0.06)' : 'rgba(255,255,255,0.06)'}`
            }} data-id="element-1845" />

                  {/* Point Section */}
                  <div className="px-2.5 pt-1 pb-1 text-[9px] font-semibold uppercase tracking-wider" style={{
              color: isLight ? '#94a3b8' : '#475569'
            }} data-id="element-1846">
                    Point
                  </div>
                  {['Point', 'City', 'POI'].map(type => <button key={type} onClick={() => handleTypeSelect(type)} className="w-full text-left px-2.5 py-1.5 text-[11px] font-medium transition-colors flex items-center justify-between" style={{
              color: activeType === type ? '#EC4899' : isLight ? '#334155' : '#e2e8f0',
              backgroundColor: activeType === type ? isLight ? 'rgba(236,72,153,0.06)' : 'rgba(236,72,153,0.1)' : 'transparent'
            }} onMouseEnter={e => {
              if (activeType !== type) {
                e.currentTarget.style.backgroundColor = isLight ? 'rgba(0,0,0,0.04)' : 'rgba(255,255,255,0.06)';
              }
            }} onMouseLeave={e => {
              if (activeType !== type) {
                e.currentTarget.style.backgroundColor = 'transparent';
              }
            }} data-id="element-1847">
                      <div className="flex items-center gap-2" data-id="element-1848">
                        {getIconForType(type)}
                        <span data-id="element-1849">{TYPE_LABELS[type]}</span>
                      </div>
                      {activeType === type && <Check size={12} className="text-[#EC4899] flex-shrink-0" data-id="element-1850" />}
                    </button>)}
                </div>}
            </div>
          </div>}
      </div>

      {/* Bottom Location Bar */}
      <div className="relative border-t" style={{
      borderColor: isLight ? 'rgba(0,0,0,0.06)' : 'rgba(255,255,255,0.06)'
    }} data-id="element-1851">
        {searchOpen /* Expanded search input */ ? <div className="relative" data-id="element-1852">
            <Search size={13} className="absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none" style={{
          color: isLight ? '#94a3b8' : '#64748b'
        }} data-id="element-1853" />
            <input ref={searchRef} value={search} onChange={e => setSearch(e.target.value)} placeholder={`Search ${activeType === 'POI' ? 'POIs' : activeType === 'City' ? 'cities' : activeType === 'Market' ? 'market zones' : activeType === 'Country' ? 'countries' : activeType === 'Area' ? 'areas' : 'locations'}...`} className="w-full h-9 pl-8 pr-8 text-[11px] font-medium border-0 focus:outline-none focus:ring-0 transition-all" style={{
          backgroundColor: isLight ? '#ffffff' : 'rgba(15,23,42,0.95)',
          color: isLight ? '#0f172a' : '#ffffff'
        }} autoFocus onKeyDown={e => {
          if (e.key === 'Escape') {
            setSearch('');
            setSearchOpen(false);
          }
        }} data-id="element-1854" />
            <button onClick={() => {
          setSearch('');
          setSearchOpen(false);
        }} className="absolute right-2.5 top-1/2 -translate-y-1/2 p-0.5 rounded-full transition-colors" style={{
          color: isLight ? '#64748b' : '#94a3b8'
        }} data-id="element-1855">
              <X size={13} data-id="element-1856" />
            </button>
          </div> /* Compact location display with pin */ : <button onClick={() => {
        if (activeType !== 'Point' && activeType !== 'Area') {
          setSearchOpen(true);
          setTimeout(() => searchRef.current?.focus(), 50);
        }
      }} className="w-full flex items-center gap-2.5 px-3 h-9 text-left transition-colors group" style={{
        backgroundColor: isLight ? '#ffffff' : 'rgba(15,23,42,0.95)',
        cursor: activeType === 'Point' || activeType === 'Area' ? 'default' : 'pointer'
      }} data-id="element-1857">
            <MapPin size={13} className="flex-shrink-0" style={{
          color: activeType === 'Point' && selectedPoints.length > 0 ? '#EC4899' : activeType === 'Area' && areaVertices.length > 0 ? '#3b82f6' : selected ? TYPE_COLORS[selected.type] || '#EC4899' : isLight ? '#cbd5e1' : '#475569'
        }} data-id="element-1858" />
            <span className="text-[11px] font-medium truncate flex-1" style={{
          color: activeType === 'Point' && selectedPoints.length > 0 || activeType === 'Area' && areaVertices.length > 0 || selected ? isLight ? '#0f172a' : '#f1f5f9' : isLight ? '#94a3b8' : '#64748b'
        }} data-id="element-1859">
              {activeType === 'Point' ? selectedPoints.length > 0 ? selectedPoints.length === 1 ? `${selectedPoints[0].lat.toFixed(2)}°N, ${selectedPoints[0].lng.toFixed(2)}°E` : `${selectedPoints.length} points selected` : 'Click map to add points' : activeType === 'Area' ? areaVertices.length > 0 ? `${areaVertices.length} vertices defined` : 'Click map to define area' : selected ? selected.name : `Search ${activeType === 'POI' ? 'POIs' : activeType === 'City' ? 'cities' : activeType === 'Market' ? 'market zones' : activeType === 'Country' ? 'countries' : 'locations'}...`}
            </span>
            {activeType !== 'Point' && activeType !== 'Area' && <PenLine size={12} className="flex-shrink-0 transition-colors" style={{
          color: isLight ? '#cbd5e1' : '#475569'
        }} data-id="element-1860" />}
          </button>}
      </div>
    </div>;
}